import { NavBarListItem } from "@/components/PageHome/api/interface";
import { routeBasePath } from "@/helpers/router";
import { DeviceInfo } from "@/interface/deviceInfo";

const getSortedLinks: (links: NavBarListItem[], pathname: string, userAgent: DeviceInfo) => any = (
  links,
  pathname,
  userAgent
) => {
  return links
    ?.map((link) => {
      const { Url } = link;
      const urlWithBasePath = `${routeBasePath}${Url}`;
      const isActive = pathname === urlWithBasePath;
      const slug = Url.split("/")?.pop();

      return {
        ...link,
        urlWithBasePath,
        isActive,
        slug,
      };
    })
    .sort((linkA: any, linkB: any) =>
      !userAgent?.isDesktop ? (linkB.isActive === true ? 1 : 0) - (linkA.isActive === true ? 1 : 0) : 0
    );
};

export { getSortedLinks };
